import api from "../../utils/Api";
import {
  SAVE_NOTES_REQUEST,
  SAVE_NOTES_SUCCESS,
  SAVE_NOTES_ERROR,
} from "./SaveNotesTypes";

export const saveNotesRequest = () => {
  return {
    type: SAVE_NOTES_REQUEST,
  };
};

export const saveNotesSuccess = (notes) => {
  return {
    type: SAVE_NOTES_SUCCESS,
    payload: notes,
  };
};

export const saveNotesFailure = (error) => {
  return {
    type: SAVE_NOTES_ERROR,
    payload: error,
  };
};

export const saveNotes = (payload) => {

    const headers = {
        'Content-Type': 'application/json',
        Authorization:
            "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
        };
  return async (dispatch) => {
    dispatch(saveNotesRequest());
    try {
        const response = await api.post("dashboard/notes/save", payload, {
            headers: headers,
          });
      const saveNotesData = response.data.data;
     // console.log("saveNotesData", saveNotesData)
      dispatch(saveNotesSuccess(saveNotesData));
    } catch (error) {
      console.log("Redux error - ", error.response.data.message);
      const errorMsg = error.response.data.message;
      dispatch(saveNotesFailure(errorMsg));
    }
  };
};
